// extracted by mini-css-extract-plugin
module.exports = {"imgContainer":"icon-file_imgContainer__1B4BT","img":"icon-file_img__-_0gC"};